<template>
  <div v-if="!notification.link" class="base-notification-item-contents-wrapper-parts">
    <slot />
  </div>

  <a
    v-else-if="isExternalLink(notification.link)"
    :href="notification.link"
    target="_blank"
    rel="noopener noreferrer"
    class="base-notification-item-contents-wrapper-parts base-notification-item-contents-wrapper-parts--link"
  >
    <slot />
  </a>

  <div
    v-else
    class="base-notification-item-contents-wrapper-parts base-notification-item-contents-wrapper-parts--link base-notification-item-contents-wrapper-parts--router-link"
    @click="clickRouterLink(notification)"
  >
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import useCheckURL from '@/components/hook/useCheckURL'
import { NotificationItemType } from '@/components/NotificationPane/NotificationPane.vue'

/**
 * Notification 詳細アイテム: リンク設定切り替えパーツ
 */
export default defineComponent({
  name: 'BaseNotificationItemContentsParts',
  props: {
    notification: {
      type: Object as PropType<NotificationItemType>,
      required: true,
    },
  },
  setup(_, context) {
    // 外部リンク判定関数取得
    const { isExternalLink } = useCheckURL()

    // アプリ内に遷移するお知らせがクリックされたことを親に伝える
    const clickRouterLink = (notification: NotificationItemType) => {
      context.emit('handlerClickLink', notification)
    }

    return {
      isExternalLink,
      clickRouterLink,
    }
  },
})
</script>

<style lang="scss" scoped>
.base-notification-item-contents-wrapper-parts {
  position: relative;
  display: flex;
  flex-direction: column;
  font-family: $fontSignup;

  &--router-link:hover {
    cursor: pointer;
  }
}
</style>
